import React from 'react';
export function CampaignPlainTextIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M5 9l.5-4h13l.5 4h-1l-1-2h-4v10l3 .5V19H8v-1.5l3-.5V7H7L6 9H5z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 23V1h22v22H1zM3 3h18v18H3V3z"
  }));
}